"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickElements = void 0;
function PickElements(originalObject, allowedElements) {
  const newObject = {};
  if (!originalObject) {
    return {};
  }
  if (!allowedElements) {
    return {};
  }
  for (const element of allowedElements) {
    if (typeof originalObject[element] !== 'undefined') {
      newObject[element] = originalObject[element];
    }
  }
  return newObject;
}
exports.PickElements = PickElements;
